import { createContext, ReactNode, useContext } from 'react'
import { useStreamerConfig } from './useStreamerConfig'
import { IStreamerConfig } from '@/pages/Donation/api/streamer/types'

type StreamerConfigContextType = {
  config: IStreamerConfig | null
  username?: string
  isLoading: boolean
  isError: boolean
}

export const StreamerConfigContext = createContext<StreamerConfigContextType>({
  config: null,
  isLoading: false,
  isError: false,
})

export function StreamerConfigProvider({ children }: { children: ReactNode }) {
  const { streamerConfig, isLoading, streamerUsername, isError } = useStreamerConfig()

  return (
    <StreamerConfigContext.Provider
      value={{
        config: streamerConfig,
        username: streamerUsername,
        isLoading,
        isError,
      }}
    >
      {children}
    </StreamerConfigContext.Provider>
  )
}

export const useStreamerConfigContext = () => useContext(StreamerConfigContext)
